import flag_al from '../img/flags/al.png'
import flag_ar from '../img/flags/ar.png'
import flag_au from '../img/flags/au.png'
import flag_at from '../img/flags/at.png'
import flag_be from '../img/flags/be.png'
import flag_br from '../img/flags/br.png'
import flag_ca from '../img/flags/ca.png'
import flag_ch from '../img/flags/ch.png'
import flag_cm from '../img/flags/cm.png'
import flag_cr from '../img/flags/cr.png'
import flag_cz from '../img/flags/cz.png'
import flag_de from '../img/flags/de.png'
import flag_dk from '../img/flags/dk.png'
import flag_ec from '../img/flags/ec.png'
import flag_es from '../img/flags/es.png'
import flag_fi from '../img/flags/fi.png'
import flag_fr from '../img/flags/fr.png'
import flag_en from '../img/flags/gb_eng.png'
import flag_gh from '../img/flags/gh.png'
import flag_hr from '../img/flags/hr.png'
import flag_hu from '../img/flags/hu.png'
import flag_ir from '../img/flags/ir.png'
import flag_is from '../img/flags/is.png'
import flag_it from '../img/flags/it.png'
import flag_jp from '../img/flags/jp.png'
import flag_kr from '../img/flags/kr.png'
import flag_ma from '../img/flags/ma.png'
import flag_mx from '../img/flags/mx.png'
import flag_nl from '../img/flags/nl.png'
import flag_no from '../img/flags/no.png'
import flag_pl from '../img/flags/pl.png'
import flag_pt from '../img/flags/pt.png'
import flag_qa from '../img/flags/qa.png'
import flag_ro from '../img/flags/ro.png'
import flag_rs from '../img/flags/rs.png'
import flag_sa from '../img/flags/sa.png'
import flag_sc from '../img/flags/gb_sco.png'
import flag_si from '../img/flags/si.png'
import flag_sk from '../img/flags/sk.png'
import flag_sn from '../img/flags/sn.png'
import flag_se from '../img/flags/se.png'
import flag_tn from '../img/flags/tn.png'
import flag_tr from '../img/flags/tr.png'
import flag_us from '../img/flags/us.png'
import flag_uy from '../img/flags/uy.png'
import flag_wl from '../img/flags/gb_wls.png'

const teams = [
  { "_id": "foot_al", "type": "country", "name": "Albania", "country": "AL", "flag": flag_al },
  { "_id": "foot_ar", "type": "country", "name": "Argentina", "country": "AR", "flag": flag_ar },
  { "_id": "foot_au", "type": "country", "name": "Australia", "country": "AU", "flag": flag_au },
  { "_id": "foot_at", "type": "country", "name": "Austria", "country": "AT", "flag": flag_at },
  { "_id": "foot_be", "type": "country", "name": "Belgium", "country": "BE", "flag": flag_be },
  { "_id": "foot_br", "type": "country", "name": "Brazil", "country": "BR", "flag": flag_br },
  { "_id": "foot_cm", "type": "country", "name": "Cameroon", "country": "CM", "flag": flag_cm },
  { "_id": "foot_ca", "type": "country", "name": "Canada", "country": "CA", "flag": flag_ca },
  { "_id": "foot_cr", "type": "country", "name": "Costa Rica", "country": "CR", "flag": flag_cr },
  { "_id": "foot_hr", "type": "country", "name": "Croatia", "country": "HR", "flag": flag_hr },
  { "_id": "foot_cz", "type": "country", "name": "Czech Republic", "country": "CZ", "flag": flag_cz },
  { "_id": "foot_hu", "type": "country", "name": "Hungary", "country": "HU", "flag": flag_hu },
  { "_id": "foot_dk", "type": "country", "name": "Denmark", "country": "DK", "flag": flag_dk },
  { "_id": "foot_ec", "type": "country", "name": "Ecuador", "country": "EC", "flag": flag_ec },
  { "_id": "foot_en", "type": "country", "name": "England", "country": "EN", "flag": flag_en },
  { "_id": "foot_fi", "type": "country", "name": "Finland", "country": "FI", "flag": flag_fi },  
  { "_id": "foot_fr", "type": "country", "name": "France", "country": "FR", "flag": flag_fr },
  { "_id": "foot_de", "type": "country", "name": "Germany", "country": "DE", "flag": flag_de },
  { "_id": "foot_gh", "type": "country", "name": "Ghana", "country": "GH", "flag": flag_gh },
  { "_id": "foot_is", "type": "country", "name": "Iceland", "country": "IS", "flag": flag_is },  
  { "_id": "foot_ir", "type": "country", "name": "Iran", "country": "IR", "flag": flag_ir },
  { "_id": "foot_it", "type": "country", "name": "Italy", "country": "IT", "flag": flag_it }, 
  { "_id": "foot_jp", "type": "country", "name": "Japan", "country": "JP", "flag": flag_jp },
  { "_id": "foot_mx", "type": "country", "name": "Mexico", "country": "MX", "flag": flag_mx },
  { "_id": "foot_ma", "type": "country", "name": "Morocco", "country": "MA", "flag": flag_ma },
  { "_id": "foot_nl", "type": "country", "name": "Netherlands", "country": "NL", "flag": flag_nl },
  { "_id": "foot_no", "type": "country", "name": "Norway", "country": "NO", "flag": flag_no },    
  { "_id": "foot_pl", "type": "country", "name": "Poland", "country": "PL", "flag": flag_pl },
  { "_id": "foot_pt", "type": "country", "name": "Portugal", "country": "PT", "flag": flag_pt },
  { "_id": "foot_qa", "type": "country", "name": "Qatar", "country": "QA", "flag": flag_qa },
  { "_id": "foot_ro", "type": "country", "name": "Romania", "country": "RO", "flag": flag_ro },
  { "_id": "foot_sa", "type": "country", "name": "Saudi Arabia", "country": "SA", "flag": flag_sa },
  { "_id": "foot_sc", "type": "country", "name": "Scotland", "country": "SC", "flag": flag_sc },
  { "_id": "foot_sn", "type": "country", "name": "Senegal", "country": "SN", "flag": flag_sn },
  { "_id": "foot_rs", "type": "country", "name": "Serbia", "country": "RS", "flag": flag_rs },
  { "_id": "foot_si", "type": "country", "name": "Slovenia", "country": "SI", "flag": flag_si },
  { "_id": "foot_sk", "type": "country", "name": "Slovakia", "country": "SK", "flag": flag_sk },
  { "_id": "foot_kr", "type": "country", "name": "South Korea", "country": "KR", "flag": flag_kr },
  { "_id": "foot_es", "type": "country", "name": "Spain", "country": "ES", "flag": flag_es },
  { "_id": "foot_se", "type": "country", "name": "Sweden", "country": "SE", "flag": flag_se },
  { "_id": "foot_ch", "type": "country", "name": "Switzerland", "country": "CH", "flag": flag_ch },
  { "_id": "foot_tn", "type": "country", "name": "Tunisia", "country": "TN", "flag": flag_tn },
  { "_id": "foot_tr", "type": "country", "name": "Turkey", "country": "TR", "flag": flag_tr },
  { "_id": "foot_us", "type": "country", "name": "United States", "country": "US", "flag": flag_us },
  { "_id": "foot_uy", "type": "country", "name": "Uruguay", "country": "UY", "flag": flag_uy },
  { "_id": "foot_wl", "type": "country", "name": "Wales", "country": "WL", "flag": flag_wl },
]

export default teams